import React, { useEffect, useState } from "react";
import { useAdvSearch } from "../../providers/advSearchCtx";
import CustomSelect from "../UI/CustomSelect";

function FiltersSelects() {
  const { params } = useAdvSearch();
  const [filtersFormSelects, setFiltersFormSelects] = useState([]);

  console.log(params);

  const categories_found = advSearch.property_types;
  let categories = [];
  categories_found.forEach((element) => {
    categories.push({
      value: element.slug,
      label: element.name,
    });
  });

  useEffect(() => {
    const filtersFormSelects = [
      {
        value: params.contratto,
        key: "contratto",
        label: "Contratto",
        options: [
          { value: "vendita", label: "Vendita" },
          { value: "affitto", label: "Affitto" },
        ],
      },
      {
        value: params.trattativa,
        key: "trattativa",
        label: "Trattativa",
        options: [
          { value: "agenzia", label: "Agenzia" },
          { value: "privato", label: "Privato" },
        ],
      },
      {
        value: params.bagni,
        key: "bagni",
        label: "Bagni",
        options: [
          { value: "1", label: "1" },
          { value: "2", label: "2" },
          { value: "3", label: "3" },
          { value: "piu-di-3", label: "Più di 3" },
        ],
      },
      {
        value: params.property_type,
        label: "Tipologia Immobile",
        key: "property_type",
        options: categories,
      },
    ];
    setFiltersFormSelects(filtersFormSelects);
  }, [params]);

  return (
    <div className="uk-flex uk-flex-middle">
      {filtersFormSelects.map((select) => (
        //console.log(select),
        <CustomSelect
          key={select.key}
          options={select.options}
          label={select.label}
          value={select.value}
        />
      ))}
    </div>
  );
}

export default FiltersSelects;
